__turbopack_context__.v({
  "hasNoContent": "verkehrsmeldungen-module-scss-module__lyzr8W__hasNoContent",
  "title": "verkehrsmeldungen-module-scss-module__lyzr8W__title",
});
